var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form-underwriting width-700"},[_c('el-form',{ref:"form",staticClass:"form-container",attrs:{"rules":_vm.rules,"model":_vm.formData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }